import { PropTypes } from 'react';
import { filterRacesWithAvailableTickets, filterRacesWithoutAvailableTickets } from './helpers';

import TicketList from './component';

/**
 * Event tickets container component, determines races with ticket availability.
 */
const TicketListContainer = ({ event: { races: { races } = {}, permalink } }) =>
  TicketList({
    eventPermalink: permalink,
    racesWithAvailableTickets: filterRacesWithAvailableTickets(races),
    racesWithoutAvailableTickets: filterRacesWithoutAvailableTickets(races),
  });

TicketListContainer.propTypes = {
  event: PropTypes.shape({
    races: PropTypes.shape({
      races: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    }),
    permalink: PropTypes.string.isRequired,
  }).isRequired,
};

export default TicketListContainer;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/EventTickets/container.js